import { render, staticRenderFns } from "./RewardsGreetingDynamic.vue?vue&type=template&id=c968105e&scoped=true"
import script from "./RewardsGreetingDynamic.vue?vue&type=script&lang=js"
export * from "./RewardsGreetingDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c968105e",
  null
  
)

export default component.exports